import React from "react";
import "./adminHeader.css"; 

const AdminHeader = () => {
  const adminName = localStorage.getItem("admin_name") || "Admin"; 
  return (
    <div className="admin-header">
      <h3>Hello, {adminName}</h3>
    </div>
  );
};

export default AdminHeader;
